import {useAppDispatch} from '@/store'
import {setToastNotifications} from '@/store/slices/commonSlice'
import {deleteComboProduct} from '@/services/ProductComboService/productComboService'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useNavigate} from 'react-router-dom'
import {Modal} from '@/components/atoms' 
import {Font} from 'pepsico-ds'

const COMBO_LIST_TAB_INDEX = 1

/**
 * Modal component for deleting a product combo. It prompts the user for confirmation before deleting the combo product.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.show - Controls the visibility of the modal
 * @param {Function} props.onClose - Callback function called when modal is closed/cancelled
 * @param {Function} props.onSubmit - Callback function called when Apply button is clicked.
 * @param {string} props.comboId - The ID of the combo product to delete\
 * @param {number} props.promotionNumber - The ID of the combo product to delete
 */

const DeleteComboProductModal = ({show, onClose, promotionNumber, comboId}) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const handleDeleteCombo = async comboId => {
        if (!comboId) {
            return
        }

        try {
            const response = await deleteComboProduct(comboId)

            if (response?.isSuccess) {
                dispatch(
                    setToastNotifications({
                        show: true,
                        message: 'Combo deleted successfully',
                        type: 'success',
                    })
                )
            }
 
            navigate(ROUTES.PRODUCTS_LIST, {state: {selectedTabNumb: COMBO_LIST_TAB_INDEX}})
           
        } catch (error) {
            let errorMessage = 'Error deleting combo product'

            if (error?.response?.data?.message) {
                errorMessage = error.response.data.message
            } else if (error?.data?.message) {
                errorMessage = error.data.message
            } else if (error?.message) {
                errorMessage = error.message
            }

            dispatch(
                setToastNotifications({
                    show: true,
                    message: errorMessage,
                    type: 'error',
                })
            )   
        }
        onClose()
    }

    const getModalDescription = () => {
        if (promotionNumber) {
            return (
                <div>
                    <Font size="small">
                        This combo product is currently associated with 
                    </Font>
                    <Font size="small" variant="bold"> {promotionNumber} active promotions. </Font>
                </div>
            )
        }
        return <Font size="small"> Delete Combo is a permanent action and cannot be undone. </Font>
    }

  return (
    <Modal
      showModal={show}
      title={'Are you sure you want to delete this combo?'}
      text={getModalDescription()}
      primaryButtonText="Yes"
      secondaryButtonText="No"
      showSecondaryButton={true}
      classNameWrapper="min-h-80"
      onClickSecondaryButton={onClose}
      onClickPrimaryButton={() => handleDeleteCombo(comboId)}
      hideCloseButton={true}
    />
  )
}

export default DeleteComboProductModal